export class FeatureTestimonial {
  constructor() {
    this.DOM = { main: document.querySelector(".js-featureTestimonial") };
    if (!this.DOM.main) return;
    this.headingItems = this.DOM.main.querySelectorAll(
      ".testimonialHeadingItem"
    );
    this.descItems = this.DOM.main.querySelectorAll(
      ".featureTestimonial_content_descItem"
    );

    this._activeInit();
    this.bindEvents();
  }

  _activeInit() {
    this.descItems[0].classList.add("active");
    this.headingItems[0].classList.add("active");
  }

  _onClick(index) {
    const activeHeadingItem = this.headingItems[index];
    const activeDescItem = this.descItems[index];

    this.headingItems.forEach((item) => {
      item.classList.contains("active") && item.classList.remove("active");
    });
    this.descItems.forEach((item) => {
      item.classList.contains("active") && item.classList.remove("active");
    });
    activeHeadingItem.classList.add("active");
    activeDescItem.classList.add("active");
  }

  bindEvents() {
    this.headingItems.forEach((item, index) => {
      item.addEventListener("click", () => this._onClick(index));
    });
  }
}
